var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowerInCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Organic-Plant--Streamline-Ultimate.svg",
    clipPath: "url(#clip0_32745_17434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.16667 23.0896C2.05631 22.2608 2.00063 21.4257 2 20.5896C2 15.6168 3.97544 10.8477 7.49175 7.33135C11.0081 3.81504 15.7772 1.8396 20.75 1.8396",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.3367 23.0896C39.4471 22.2608 39.5028 21.4257 39.5033 20.5896C39.5033 18.127 39.0182 15.6886 38.0758 13.4135C37.1333 11.1384 35.7519 9.07131 34.0104 7.33017C32.269 5.58903 30.2016 4.20798 27.9263 3.2659C25.6511 2.32382 23.2126 1.83916 20.75 1.8396",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.5017 20.6663C32.6937 20.668 30.9039 21.0259 29.2343 21.7195C27.5647 22.4131 26.0481 23.4288 24.7711 24.7085C23.4941 25.9883 22.4817 27.5071 21.7917 29.1783C21.1018 30.8494 20.7478 32.64 20.75 34.4479C22.5579 34.446 24.3476 34.0879 26.0171 33.3943C27.6866 32.7006 29.2032 31.6849 30.4801 30.4052C31.7571 29.1254 32.7695 27.6067 33.4595 25.9357C34.1495 24.2647 34.5036 22.4741 34.5017 20.6663Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.3682 25.1313C25.3114 22.4266 25.474 19.5109 24.8373 16.7181C24.2007 13.9253 22.7905 11.3682 20.7682 9.3396C18.7379 11.3757 17.3245 13.9442 16.6911 16.7489C16.0577 19.5536 16.23 22.4803 17.1882 25.1913",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.75 34.4479C20.754 30.7971 19.3076 27.2941 16.729 24.7096C14.1505 22.1251 10.6509 20.6707 7.00001 20.6663C6.99782 22.474 7.35175 24.2646 8.04159 25.9356C8.73142 27.6065 9.74366 29.1253 11.0205 30.4051C12.2973 31.6848 13.8137 32.7006 15.4831 33.3942C17.1525 34.0879 18.9422 34.446 20.75 34.4479Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.7515 39.3397V34.448",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M37.9452 28.0762C37.3365 29.4948 36.5466 30.8287 35.5952 32.0445",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.98 35.5996C30.7524 36.5336 29.4076 37.3023 27.98 37.8863",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.5615 37.8863C12.1332 37.3037 10.7883 36.5348 9.56152 35.5996",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M5.9418 32.0445C4.99009 30.829 4.20016 29.495 3.5918 28.0762",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32745_17434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.75 0.5896)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerInCircle);
export default __webpack_public_path__ + "static/media/flowerInCircle.da35e9c3732854df4bcc154ede22a0ce.svg";
export { ForwardRef as ReactComponent };